import { createRefetchContainer, graphql } from 'react-relay';
import EventShowComponent from './';

export default createRefetchContainer(
  EventShowComponent,
  {
    viewer: graphql`
      fragment EventShowContainer_viewer on User {
        id
        past_referral_sources
        c_templates {
          edges {
            node {
              id
              title
            }
          }
        }
        form_templates {
          edges {
            node {
              id
              title
            }
          }
        }
        mp_templates {
          edges {
            node {
              id
              title
            }
          }
        }
        features {
          music_lists
        }
        ...EventSummaryContainer_viewer
        ...AvailabilityCheckerContainer_viewer
        ...AvailabilityCalendarContainer_viewer
      }
    `,
    node: graphql`
      fragment EventShowContainer_node on Event {
        id
        start_at
        end_at
        all_day
        time_zone
        title
        can_edit
        user_event {
          id
          booking_status
          visibility
          start_at
          end_at
          time_zone
        }
        workspaces(first: 99999) @connection(key: "EventShowContainer_workspaces") {
          edges {
            node {
              id
              title
              contracts(first: 99999) @connection(key: "EventShowContainer_contracts"){
                edges {
                  node {
                    id
                    title
                  }
                }
              }
              estimates(first: 99999) @connection(key: "EventShowContainer_estimates"){
                edges {
                  node {
                    id
                    title
                  }
                }
              }
              forms(first: 99999) @connection(key: "EventShowContainer_forms"){
                edges {
                  node {
                    id
                    title
                  }
                }
              }
              invoices(first: 99999) @connection(key: "EventShowContainer_invoices"){
                edges {
                  node {
                    id
                    title
                  }
                }
              }
              music_planners(first: 99999) @connection(key: "EventShowContainer_music_planners"){
                edges {
                  node {
                    id
                    title
                  }
                }
              }
            }
          }
        }
        ...EventSummaryContainer_node
      }
    `,
  },
  graphql`
    query EventShowContainer_RefetchQuery($id: ID!) {
      node(id: $id) {
        ...EventShowContainer_node
      }
    }
  `
);



// WEBPACK FOOTER //
// ./webpack/components/Event/Show/EventShowContainer.js